import { render, staticRenderFns } from "./CoDropdownListV2.vue?vue&type=template&id=313a8845&scoped=true&"
import script from "./CoDropdownListV2.vue?vue&type=script&lang=ts&"
export * from "./CoDropdownListV2.vue?vue&type=script&lang=ts&"
import style0 from "./CoDropdownListV2.vue?vue&type=style&index=0&id=313a8845&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a8845",
  null
  
)

export default component.exports